import { suggestCallsign } from '../game/callsigns';

const RUNNER_KEY = 'graphquest.runner.v1';

export function loadRunnerName(): string | null {
  try {
    return localStorage.getItem(RUNNER_KEY);
  } catch {
    return null;
  }
}

export function saveRunnerName(name: string | null): void {
  try {
    if (name === null) localStorage.removeItem(RUNNER_KEY);
    else localStorage.setItem(RUNNER_KEY, name);
  } catch {}
}

export function ensureRunnerName(): string {
  const stored = loadRunnerName();
  if (stored) return stored;
  const suggested = suggestCallsign();
  saveRunnerName(suggested);
  return suggested;
}
